module.exports = __webpack_public_path__ + "static/img/second3.db93e8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/second3.png
// module id = liZt
// module chunks = 25